<template>
  <!-- Fields -->
  <section class="shipping-block">

    <!-- Street field -->
    <base-input class="col-xs-12 mb10 input shipping-block-field"
                type="text"
                name="street-address"
                autocomplete="address-line1"
                :placeholder="`${$t('Street name')} *`"
                :maxlength="60"
                v-model.trim="address.street"
                @blur="$v.address.street.$touch()"
                @input="updateAddress"
                :validations="[
                  {
                    condition: !$v.address.street.required && $v.address.street.$error,
                    text: $t('Field is required')
                  }
                ]"
    />
    <!---->

    <!-- House field -->
    <base-input class="col-xs-12 mb10 input shipping-block-field"
                type="text"
                name="house-number"
                autocomplete="address-line2"
                :placeholder="`${$t('House number')} *`"
                :maxlength="10"
                v-model.trim="address.house"
                @blur="$v.address.house.$touch()"
                @input="updateAddress"
                :validations="[
                  {
                    condition: !$v.address.house.required && $v.address.house.$error,
                    text: $t('Field is required')
                  }
                ]"
    />
    <!---->
  </section>
</template>
<script>
import ButtonFull from 'theme/components/theme/ButtonFull.vue';
import { required } from 'vuelidate/lib/validators';

const BaseInput = () => import(/* webpackChunkName: "vsf-base-input" */ 'theme/components/core/blocks/Form/BaseInput');

export default {
  components: {
    ButtonFull,
    BaseInput
  },
  props: {
    currentAddress: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    address: {
      street: '',
      house: ''
    }
  }),
  mounted () {
    if (this.currentAddress) {
      this.address = {
        street: this.currentAddress.address.road,
        house: this.currentAddress.address.house_number
      }
    }
  },
  validations () {
    return {
      address: {
        street: {
          required
        },
        house: {
          required
        }
      }
    }
  },
  methods: {
    updateAddress () {
      this.$emit('address-updated', this.address)
    }
  }
}
</script>
<style lang="scss">
#pickup-checkout {
  .shipping-address {
    width: 100%;

    .vti__dropdown {
      left: 5px;
    }

    .phoneinput input {
      padding-left: 100px;
    }

    .phoneinput label {
      left: 90px;
      top: 12px;
    }
  }
}
.textarea-custom-for-gift {
  max-height: 52px;
  textarea {
    border: none;
    min-height: 55px;
    margin-top: 0;
  }
}

</style>
<style lang="scss" scoped>
::placeholder {
  color: #bdbdbd;
  font-family: "TTNorms Regular", serif;
}
.counter {
  margin-left: 2px;
}
.textarea-custom {
  width: 100%;
  resize: none;
  border: 1px solid #cecdcd;
  border-radius: 10px;
  padding: 10px;
}
.comment {
  padding: 0 8px;
  margin-bottom: 40px;
}
</style>
